import React from 'react';
import { Slider } from '@material-ui/core';

export default function KenSlider(props) {
  const { value2, handleChange2, max, min, handleOnChangeCommitted } = props;
  return (
    <div>
      <Slider
        style={{ width: '300px', color: '#0077FF'}}
        getAriaLabel={() => 'Minimum distance shift'}
        value={value2}
        onChange={handleChange2}
        valueLabelDisplay="auto"
        onChangeCommitted={handleOnChangeCommitted}
        //  getAriaValueText={valuetext}
        // disableSwap
      />
    </div>
  );
}
